module.exports = __webpack_public_path__ + "static/aws-6ff6a5ec2e69dbab5b646e2ccbe096ab.png";